import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'CHANNEL' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/handlers.js